import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import bg from '../../images/slider/invitation-bg.jpg'
import cImg1 from '../../images/couple/3.jpg'
import monograma from '../../images/couple/monograma.png'
import flower from '../../images/couple/couple-flower.png'
import shape from '../../images/slider/date-shape.png'
import { Button, } from '@mui/material'

import RsvpSection from '../../components/RsvpSection/RsvpSection';



const InvitationPage = () => {
    const { handle } = useParams();
    const [showRsvpForm, setShowRsvpForm] = useState(false);
    const [invitationData, setInvitationData] = useState({
        guests_count: 0,
        name: '...'
    });
    const [isLoading, setIsLoading] = useState(true);

    const host = 'https://marioydaniela.com/api'
    // const host = 'http://192.168.16.2:5000'

    useEffect(() => {
        const fetchInvitationData = async () => {
            try {
                const requestOptions = {
                    method: "GET",
                    redirect: "follow"
                };

                const response = await fetch(`${host}/invitation-data/${handle}`, requestOptions);
                const result = await response.json();
                setInvitationData(result);
            } catch (error) {
                console.error('Error fetching invitation data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInvitationData();
    }, [handle]);

    const handleBackFromRsvp = () => {
        setShowRsvpForm(false);
    };

    const renderMainContent = () => (
        <>
            <div className="middle-couple-pic-inner">
                <img src={monograma} alt="" className='w-50' />
            </div>
            <div className="wpo-invitation-info">
                <h2>{isLoading ? '...' : invitationData.name}</h2>
                <p>
                    Nos complace {isLoading ? '...' : (invitationData.guests_count > 1 ? 'invitarles ' : 'invitarte ')}
                    a nuestra boda, que se llevará a cabo el
                </p>
                <span className="shape"><img src={shape} alt="" /> </span>
                <h2 className='date-text'>
                    06/diciembre/2025
                </h2>
            </div>
            <div className="wpo-event-text">
                <h2>Recepción</h2>
                <p>
                    <strong>16:00 horas</strong>
                </p>
                <p>
                    Estacionamiento (limitado) y traslado en trajinera
                </p>
                <Button
                    className={`btn`}
                    onClick={() => window.open('https://maps.app.goo.gl/Muh1u8Kwx42T8Dty7', '_blank')}>
                    📍 Ver ubicación
                </Button>
                <p>
                    Hermenegildo Galeana 260, Barrio Xaltocan, Xochimilco, CDMX
                </p>
            </div>
            <div className="wpo-event-text">
                <h2>Ceremonia</h2>
                <p>
                    <strong>17:00 horas</strong>
                </p>
                <p>
                    Hacienda Zacapa
                </p>
                <Button
                    className={`btn`}
                    onClick={() => window.open('https://maps.app.goo.gl/kfoFMNg5vJ4qBP8q8', '_blank')}>
                    📍 Ver ubicación
                </Button>
                <p>
                    Calle Francisco Zarco 1, San Jerónimo, Xochimilco, 16420, CDMX.
                </p>
                <p>
                    Agradecemos tu puntualidad, la ceremonia comenzará en tiempo.
                </p>
            </div>
            <div className="wpo-event-text">
                <h2>Código de vestimenta</h2>
                <p>
                    Formal.
                </p>
                <p>
                    Nos reservamos el color blanco, sage y verde botella.
                </p>
            </div>
            <div className="wpo-event-text assistance">
                <h2>Asistencia</h2>
                <p>Hemos reservado</p>
                <p>
                    {isLoading ? '00' : String(invitationData.guests_count).padStart(2, '0')}
                </p>
                <p> lugar{invitationData.guests_count > 0 ? 'es' : ''} en tu honor</p>
                <Button
                    className={`btn`}
                    onClick={() => setShowRsvpForm(true)}>
                    Confirma tu asistencia aquí
                </Button>
            </div>
            <div className="wpo-event-text">
                <h2>Notas</h2>
                <p>
                    Aunque nos encantaría compartir este día con los más pequeños/as,
                    por su seguridad — debido al acceso en trajinera y la cercanía a los
                    canales — recomendamos no asistir con niños/as menores de 09 años.
                </p>
                <p>
                    Agradecemos mucho tu comprensión.
                </p>
            </div>
            <div className="wpo-event-text">
                <p>
                    Te sugerimos mantenerte atento/a a las actualizaciones en nuestra página web, donde encontrarás recomendaciones, mesa de regalos y más detalles del evento:
                </p>
                <Button
                    className={`btn`}
                    onClick={() => window.open('https://marioydaniela.com', '_blank')}>
                    Nuestra página
                </Button>
            </div>
            <div className="wpo-event-text" style={{ marginTop: '50px' }}>
                <p>
                    ¿Dudas o necesitas ayuda?
                    Contacta a nuestra coordinadora de evento, Ericka Lazarini:
                </p>
                <p>
                    <a
                        href="https://wa.me/525522719079"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline', color: 'inherit' }}
                    >
                        📞 +52 55 2271 9079
                    </a>
                </p>
            </div>
            <div className="middle-couple-pic">
                <div className="middle-couple-pic-inner">
                    <img src={cImg1} alt="" />
                </div>
                <div className="couple-flower">
                    <img src={flower} alt="" />
                </div>
            </div>
        </>
    );

    return (
        <Fragment>
            <section className="wpo-invitation-area section-padding" style={{ backgroundImage: `url(${bg})` }}>
                <div className="container-fluid">
                    <div className="wpo-invitation-wrap">
                        <div className="wpo-invitation-inner-item">
                            <div className="wpo-invitation-inner text-center">
                                {showRsvpForm ? (
                                    <RsvpSection 
                                        rClass={'pt-120'} 
                                        guestsCount={invitationData.guests_count}
                                        host={host}
                                        handle={handle}
                                        onBack={handleBackFromRsvp}
                                    />
                                ) : (
                                    renderMainContent()
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
};

export default InvitationPage;